module.exports = __webpack_public_path__ + "static/Club-house-Lobby-01fcf21e509e6941af62f9c524adc32d.jpg";